import React from 'react';
import { COLORS } from '../../theme';

const VARIANT_COLORS = {
  primary: COLORS.primary,
  danger: COLORS.red,
  success: COLORS.green,
};

function ApiButton({
  loading,
  children,
  onClick,
  variant = 'primary',
  disabled,
  style = {},
  ...props
}) {
  const bg = VARIANT_COLORS[variant] || COLORS.primary;
  const isDisabled = Boolean(loading || disabled);

  return (
    <button
      onClick={!loading ? onClick : undefined}
      disabled={isDisabled}
      style={{
        background: bg,
        color: '#fff',
        opacity: isDisabled ? 0.7 : 1,
        cursor: loading ? 'not-allowed' : 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        minHeight: 44,
        padding: '8px 16px',
        border: 'none',
        borderRadius: 10,
        fontWeight: 600,
        ...style,
      }}
      {...props}
    >
      {loading && (
        <div
          style={{
            width: 16,
            height: 16,
            border: '2px solid white',
            borderTopColor: 'transparent',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
          }}
        />
      )}
      {children}
    </button>
  );
}

export default ApiButton;
